module.exports = __webpack_public_path__ + "img/setting.83c201dc.svg";